import Util from '../util'
import Api from '../api'

const api = new Api()
const util = new Util()

/**
 * /manage/joboffers 以下で利用するメソッド
 */
export default class ManageJoboffers {
  constructor () {
    this.current_max_adspotnum = 1 // manage/joboffers/new addSpotDOMを追加するときのカウンター
  }

  /**
   * manage/joboffers/new 料金シミュレーションの再計算イベントアクション
   */
  reCalc () {
    const checkWraps = document.querySelectorAll('[data-adspotnum]');
    let total = 0
    const tgt = document.querySelector('#js-totalPrice')
    for (let i = 0; i < checkWraps.length; i++) {
      const tgt1 = checkWraps[i].querySelector('.adarea')
      const tgt2 = checkWraps[i].querySelector('.admaster_id')
      const tgt3 = checkWraps[i].querySelector('[name="adspots[][num]"]')
      const tgt4 = checkWraps[i].querySelector('[name="adspots[][color]"]')
      const tgt5 = checkWraps[i].querySelector('[name="adspots[][ad_position_id]"]')
      if (tgt1.value && tgt2.value && tgt3.value && tgt4.value && tgt5.value) {
        // エリアid
        const areaid = tgt1.value - 0
        // 枠数
        const wakuNum = tgt3.value - 0
        // カラー
        const color = tgt4.value - 0
        // 掲載位置
        const position = tgt5.value - 0

        let areaBasePrice = 0
        let colorOpt = 0
        let positionOpt = 0

        // エリア
        switch (areaid) {
          case 1: // 北信
            areaBasePrice = 50000 * wakuNum
            break
          case 2: // 東信
            areaBasePrice = 45000 * wakuNum
            break
          case 3: // 南信
            areaBasePrice = 35000 * wakuNum
            break
          case 4: // 中信
            areaBasePrice = 40000 * wakuNum
            break
        }

        // カラーオプション
        if (color === 1) {
          colorOpt = 10000 * wakuNum
        }

        // 掲載位置オプション
        if (position === 1) {
          // 一面
          positionOpt = 5000 * wakuNum
        } else if (position === 3) {
          // 最終面
          positionOpt = 2000 * wakuNum
        }

        // 合計
        total += (areaBasePrice + colorOpt + positionOpt)
      }
    }

    tgt.innerText = String(total).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円'
  }

  /**
   * manage/joboffers/new 料金シミュレーションの再計算イベント付与
   */
  calcPriceSimulation () {
    const btn = document.getElementById('js-reCalc')
    const simulationTgt = document.querySelector('.simulation-wrap')

    if (!simulationTgt) {
      return false;
    }

    const adareas = document.querySelectorAll('[name="adareas[][num]"]')
    const admasters = document.querySelectorAll('.admaster_id')
    const nums = document.querySelectorAll('[name="adspots[][num]"]')
    const colors = document.querySelectorAll('[name="adspots[][color]"]')
    const positions = document.querySelectorAll('[name="adspots[][ad_position_id]"]')

    util.setEventsRtSelf('change', adareas, this.reCalc.bind(this))
    util.setEventsRtSelf('change', admasters, this.reCalc.bind(this))
    util.setEventsRtSelf('change', nums, this.reCalc.bind(this))
    util.setEventsRtSelf('change', colors, this.reCalc.bind(this))
    util.setEventsRtSelf('change', positions, this.reCalc.bind(this))

    this.reCalc()
  }

  /**
   * manage/joboffers/new 掲載地域から選択可能な日時を取得するイベント本体
   */
  actGetAdmasters (self) {
    const selectedOpt = self.querySelector('option:checked')
    const ptxt = selectedOpt.value

    let triggerCount = ''
    let tgtAdmaster = ''
    let admasterListMsg = ''

    if (ptxt) {
      triggerCount = self.getAttribute('data-adspotcount')
      tgtAdmaster = document.querySelector('.admaster_id[data-adspotcount="' + triggerCount + '"]')
      admasterListMsg = document.querySelector('[data-errormsg_admasterslist="' + triggerCount + '"]')
      admasterListMsg.innerHTML = ''

      // パラメータのセット
      api.setRparamsObj('getAdmastersLists', 'ad_area', ptxt)
      // APIを叩く
      api.manageApi('getAdmastersLists', (data) => {
        if (data.status == 200 && data.data && tgtAdmaster) {
          tgtAdmaster.innerHTML = ''
          const resultdata = data.data
          for (let i = 0; i < resultdata.length; i++) {
            const opt = document.createElement('option')
            let limit = ''
            if (resultdata[i].nor == 0) {
              limit = '満枠'
              opt.setAttribute('data-limit', true)
            } else {
              opt.setAttribute('data-limit', false)
            }
            opt.innerHTML = resultdata[i].gou_date + "（締切" + resultdata[i].limit_date  + "）" + limit
            opt.value = resultdata[i].id
            tgtAdmaster.appendChild(opt)
          }

          // 関連枠をアクティブに戻す
          const tgts = document.querySelectorAll('[data-adspotcount="' + triggerCount + '"]')
          this.canChangeSelects(tgts)

          // デフォルトが満枠だった場合、枠・カラー・掲載面を選択不可にする
          this.checkFullAdspot(tgtAdmaster)
        } else {
          admasterListMsg.innerHTML = '<strong class="t-color-red">' + data.message + '</strong>'
          tgtAdmaster.innerHTML = '<option>選択してください</option>'
        }
      })
    } else {
      // 非アクティブに戻す
      this.noChangeSelects()
    }
  }

  /**
   * manage/joboffers/new 広告枠のセレクトボックスを切り替えたときに満枠かどうかをチェックするイベント
   */
  checkFullAdspot (self) {
    const selectedOpt = self.querySelector('option:checked')
    const triggerCount = self.getAttribute('data-adspotcount')
    const tgts = document.querySelectorAll('[data-adspotcount="' + triggerCount + '"]')

    if (selectedOpt.getAttribute('data-limit') === 'true') {
      // 満枠の場合
      for (let j = 0; j < tgts.length; j++) {
        if (!tgts[j].classList.contains('adarea') && !tgts[j].classList.contains('admaster_id')) {
          tgts[j].classList.add('nochange')
        }
      }
    } else {
      this.canChangeSelects(tgts)
    }
  }

  /**
   * manage/joboffers/new
   selectを変更できるようclass名を外す（単体）
   */
  canChangeSelects (tgts) {
    for (let j = 0; j < tgts.length; j++) {
      if (!tgts[j].classList.contains('adarea')) {
        tgts[j].classList.remove('nochange')
      }
    }
  }

  /**
   * manage/joboffers/new
   selectを変更できないようにclass名を付ける（全件）
   */
  noChangeSelects () {
    // 既存の要素をチェックし、変更できないclass名を付ける
    const checkWraps = document.querySelectorAll('[data-adspotnum]');
    for (let i = 0; i < checkWraps.length; i++) {
      // 掲載地域選択セレクトボックス
      const tgt1 = checkWraps[i].querySelector('.adarea')
      if (!tgt1.value) {
        const adspotcount = checkWraps[i].getAttribute('data-adspotnum')

        // data-adspotcountの値が同じものを検索しdisabledにする
        const tgts = checkWraps[i].querySelectorAll('[data-adspotcount]')
        for (let j = 0; j < tgts.length; j++) {
          if (!tgts[j].classList.contains('adarea')) {
            tgts[j].classList.add('nochange')
          }
        }
      }
    }
  }

  /**
   * manage/joboffers/new
   掲載地域から選択可能な日時を取得するイベントをセット・すでに日時がある場合は選択済み項目をselectedにする
   */
  getAdmasters () {
    const tgts = document.querySelectorAll('.adarea')
    if (!tgts) {
      return false
    }

    this.noChangeSelects()

    // 掲載地域セレクトボックスにchangeイベントの付与
    util.setEventsRtSelf('change', tgts, this.actGetAdmasters.bind(this))

    // 広告枠セレクトボックスにchangeイベントの付与 + 初回実行
    const admasterIdSelects = document.querySelectorAll('.admaster_id')
    util.setEventsRtSelf('change', admasterIdSelects, this.checkFullAdspot.bind(this))

    const selects = document.querySelectorAll('[data-admasterdefault]')
    for (let i = 0; i < selects.length; i++) {
      const num = selects[i].getAttribute('data-admasterdefault')
      if (num) {
        selects[i].value = num
        // 広告枠セレクトボックスのchangeイベントを初回実行
        this.checkFullAdspot(selects[i])
      }
    }
  }

  /**
   * manage/joboffers/new addSpotDOMを追加
   */
  addAdspot () {
    this.current_max_adspotnum = document.querySelectorAll('[data-adspotnum]').length;
    // console.log(this.current_max_adspotnum)
    const btn = document.querySelector('[data-addbtn]')
    if (!btn) {
      return false
    }
    const tgtname = btn.getAttribute('data-addbtn')
    const tgt = document.querySelector('[data-addtgt="' + tgtname + '"]')
    if (!tgt) {
      return false
    }

    /**
     adspotのDOM要素を作成
     * @param {integer} currentNum 追加するDOMオブジェクトの番号
     * @return {object} 作成したDOMオブジェクトを返す
     */
    const createDom = (currentNum) => {
      const newAdspot = document.createElement('tr')
      newAdspot.className = 'field field-body'
      newAdspot.setAttribute('data-adspotnum', currentNum)

      const td1 = document.createElement('td')
      td1.className = 'field-contents'
      td1.innerHTML = `
      <div class="field-index">
      <select name="adspots[][num]" id="adspots__num" data-adspotcount="${currentNum}" class="nochange adspot_select_num">
      <option value="1">1枠</option>
      <option value="2">2枠</option>
      <option value="4">4枠</option>
      <option value="8">8枠</option>
      <option value="16">16枠</option>
      </select>
      </div>
      `

      const td1AdspotWrap = document.createElement('div')
      td1AdspotWrap.className = 'field-index'
      const td1AdspotSelect = document.createElement('select')
      td1AdspotSelect.setAttribute('name', 'admaster_id' + currentNum)
      td1AdspotSelect.className = 'admaster_id nochange'
      td1AdspotSelect.setAttribute('data-adspotcount', currentNum)
      td1AdspotSelect.setAttribute('data-admasterdefault', '')
      td1AdspotSelect.innerHTML = '<option>選択してください</option>'
      td1AdspotWrap.appendChild(td1AdspotSelect)
      td1.insertBefore(td1AdspotWrap, td1.firstChild)

      td1AdspotSelect.addEventListener('change', () => {
        this.checkFullAdspot.bind(this)(td1AdspotSelect)
      }, false)

      // エリア選択のイベント付与
      const td1selectWrap = document.createElement('div')
      td1selectWrap.className = 'field-index'
      const td1select = document.createElement('select')
      td1select.setAttribute('name', 'adareas[][num]')
      td1select.setAttribute('data-adspotcount', currentNum)
      td1select.className = 'adarea'
      td1select.innerHTML = `
      <option value="">選択してください</option>
      <option value="1">北信</option>
      <option value="2">東信</option>
      <option value="4">中信・諏訪地域</option>
      `
      td1select.addEventListener('change', () => {
        this.actGetAdmasters.bind(this)(td1select)
      }, false)

      td1selectWrap.appendChild(td1select)
      td1.insertBefore(td1selectWrap, td1.firstChild)

      const td2= document.createElement('td')
      td2.className = 'field-contents'
      td2.innerHTML = `
      <div class="field-index">
      <select name="adspots[][color]" id="adspots__color" data-adspotcount="${currentNum}" class="nochange adspot_select_color">
      <option value="0">モノクロ</option>
      <option value="1">カラー</option>
      </select>
      </div>
      `

      const td3 = document.createElement('td')
      td3.className = 'field-contents'
      td3.innerHTML = `
      <div class="field-index">
      <select name="adspots[][ad_position_id]" id="adspots__ad_position_id" data-adspotcount="${currentNum}" class="nochange">
      <option value="2">中面</option>
      <option value="1">一面</option>
      <option value="3">最終面</option></select>
      </div>
      `

      const td4 = document.createElement('td')
      td4.className = 'field-contents field-msg'
      td4.innerHTML = `
      <div data-errormsg_admasterslist="${currentNum}"></div>
      <div data-errormsg_validerror="${currentNum}"></div>
      `

      const td5 = document.createElement('td')
      const deletebtn = document.createElement('button')
      deletebtn.setAttribute('type', 'button')
      deletebtn.setAttribute('data-adspotdelete', currentNum)
      deletebtn.innerHTML = '<i class="fas fa-times"></i>'
      // 削除ボタンのイベント付与
      util.setEventsRtSelfSingle('click', deletebtn, this.deleteAdspotRow.bind(this))
      td5.appendChild(deletebtn)

      newAdspot.appendChild(td1)
      newAdspot.appendChild(td2)
      newAdspot.appendChild(td3)
      newAdspot.appendChild(td4)
      newAdspot.appendChild(td5)

      return newAdspot
    }

    /**
     adspotを追加するイベント
     * @param {self} 自身のオブジェクト
     */
    const addDom = (self) => {
      const addSpotDom = createDom(this.current_max_adspotnum)
      tgt.appendChild(addSpotDom)
      this.current_max_adspotnum++

      const adareas = addSpotDom.querySelector('[name="adareas[][num]"]')
      const admasters = addSpotDom.querySelector('.admaster_id')
      const nums = addSpotDom.querySelector('[name="adspots[][num]"]')
      const colors = addSpotDom.querySelector('[name="adspots[][color]"]')
      const positions = addSpotDom.querySelector('[name="adspots[][ad_position_id]"]')
      util.setEventsRtSelfSingle('change', adareas, this.reCalc.bind(this))
      util.setEventsRtSelfSingle('change', admasters, this.reCalc.bind(this))
      util.setEventsRtSelfSingle('change', nums, this.reCalc.bind(this))
      util.setEventsRtSelfSingle('change', colors, this.reCalc.bind(this))
      util.setEventsRtSelfSingle('change', positions, this.reCalc.bind(this))

      this.reCalc()
    }

    btn.addEventListener('click', () => {
      addDom(btn)
    }, false)
  }

  /**
   * manage/joboffers/new addSpotDomの行を削除イベントをセット
   */
  setDeleteAdspotRow () {
    const deleteBtns = document.querySelectorAll('[data-adspotdelete]')
    if (!deleteBtns) {
      return false
    }

    util.setEventsRtSelf('click', deleteBtns, this.deleteAdspotRow.bind(this))
  }

  /**
   * manage/joboffers/new addSpotDomの行を削除イベント
   */
  deleteAdspotRow (self) {
    const num = self.getAttribute('data-adspotdelete')
    if (!num) {
      return false;
    }

    // 件数が1件だったら削除せず
    const tgtAll = document.querySelectorAll('[data-adspotnum]')
    if (!tgtAll || tgtAll.length === 1) {
      return false;
    }

    const tgt = document.querySelector('[data-adspotnum="' + num + '"]')
    if (tgt) {
      tgt.parentNode.removeChild(tgt)
    }

    this.reCalc()
  }

  /**
   * manage, manage/joboffers 広告主がjobofferの広告枠（adspot）を確定
   */
  doneAdspotRegister () {
    const btns = document.querySelectorAll('[data-adspot_statechange]')

    const changeStatusCb = (self) => {
      if(confirm('入力内容に間違いないですか？')){
        const id = self.getAttribute('data-adspot_statechange')
        const errormsg = document.querySelector('[data-adspot_stateChangeMsg="' + id + '"]')

        try {
          if (!id) {
            throw "validerror"
          }

          errormsg.innerHTML = ''

          api.setRparamsObj('doneAdspotRegister', 'id', id)

          api.manageApi('doneAdspotRegister', (data) => {
            if (data.data) {
              self.parentNode.innerHTML = `<span class="t-color-blue success-msg">${data.message}</span>`
              location.reload(true)
            } else {
              errormsg.innerHTML = data.message
            }
          })
        } catch (e) {
          errormsg.innerHTML = "システムエラーです。管理者に連絡してください"
        }
      }
    }

    util.setEventsRtSelf('click', btns, changeStatusCb.bind(this))
  }

  /**
   * manage, manage/joboffers 求人確定後、広告会社がjobofferの確定ステータスを変更
   */
  changeStatus () {
    /* ポップアップの開閉処理 */
    const popupBtns = document.querySelectorAll('[data-joboffer_popup]')
    const popupCloseBtn = document.querySelectorAll('[data-joboffer_popup_close]')
    const bg = document.createElement('div')
    bg.className = 'manage-overlay manage-overlay-joboffer-popup'
    document.body.appendChild(bg)

    const popupClose = (self) => {
      const id = self.getAttribute('data-joboffer_popup_close')
      const tgt = document.querySelector('[data-joboffer_popup_tgt="' + id + '"]')
      const errormsg = document.querySelector('[data-statechangemsg="' + id + '"]')

      if (tgt) {
        tgt.classList.remove('show')
        setTimeout(() => {
          tgt.classList.remove('active')

          // エラーメッセージを消去
          if (errormsg) {
            errormsg.innerHTML = ''
          }
        }, 250)
      }

      if (bg) {
        bg.setAttribute('data-joboffer_popup_close', '')
        bg.classList.remove('show')
        setTimeout(() => {
          bg.classList.remove('active')
        }, 250)
      }
    }

    const popupCb = (self) => {
      const id = self.getAttribute('data-joboffer_popup')
      const tgt = document.querySelector('[data-joboffer_popup_tgt="' + id + '"]')

      if (tgt) {
        tgt.classList.add('active')
        setTimeout(() => {
          tgt.classList.add('show')
        }, 10)
      }

      if (bg) {
        bg.setAttribute('data-joboffer_popup_close', id)
        bg.classList.add('active')
        setTimeout(() => {
          bg.classList.add('show')
        }, 10)
      }
    }
    util.setEventsRtSelf('click', popupBtns, popupCb.bind(this))
    util.setEventsRtSelf('click', popupCloseBtn, popupClose.bind(this))
    util.setEventsRtSelfSingle('click', bg, popupClose.bind(this))

    /* ポップアップ内の確定ボタン APIを叩く処理 */
    const btns = document.querySelectorAll('[data-joboffer_statechange]')

    const changeStatusCb = (self) => {
      const id = self.getAttribute('data-joboffer_statechange')
      const errormsg = document.querySelector('[data-stateChangeMsg="' + id + '"]')

      self.setAttribute("disabled", "disabled")

      try {
        if (!id) {
          throw "validerror"
        }
        const agency_picname = document.querySelector('[data-stateChangeGroup="' + id + '"][name="agency_picname"]')
        const branch_office = document.querySelector('[data-stateChangeGroup="' + id + '"][name="branch_office"]')

        if (agency_picname.value && agency_picname.value.length > 40) {
          throw "validerror_maxlength"
        }

        if (!branch_office.value) {
          throw "validerror_required"
        }

        errormsg.innerHTML = ''

        api.setRparamsObj('changeJobofferStatus', 'id', id)
        api.setRparamsObj('changeJobofferStatus', 'agency_picname', agency_picname.value)
        api.setRparamsObj('changeJobofferStatus', 'branch_office', branch_office.value)

        api.manageApi('changeJobofferStatus', (data) => {
          if (data.data) {
            // 成功
            self.parentNode.innerHTML = `<span class="t-color-blue success-msg">${data.message}</span>`
            location.reload(true)
          } else {
            errormsg.innerHTML = data.message
            self.removeAttribute("disabled")
          }
        })
      } catch (e) {
        if (e === 'validerror_required') {
          errormsg.innerHTML = "「信毎支社」は必須項目です"
        } else if (e === 'validerror_maxlength') {
          errormsg.innerHTML = "「自社担当支社・担当者」は最大40文字です"
        } else {
          errormsg.innerHTML = "システムエラーです。管理者に連絡してください"
        }

        self.removeAttribute("disabled")
      }

    }

    util.setEventsRtSelf('click', btns, changeStatusCb.bind(this))
  }

  /**
   * manage, manage/joboffers:url_token 管理者が支社を変更
   */
  changeBranchOffice() {
    const btns = document.querySelectorAll('[data-joboffer_branch_office_change]')

    const changeStatusCb = (self) => {
      const id = self.getAttribute('data-joboffer_branch_office_change')
      const errormsg = document.querySelector('[data-stateChangeMsg="' + id + '"]')

      try {
        if (!id) {
          throw "validerror"
        }
        const branch_office = document.querySelector('[data-stateChangeGroup="' + id + '"][name="branch_office"]')

        if (!branch_office.value) {
          throw "validerror_required"
        }

        errormsg.innerHTML = ''

        api.setRparamsObj('changeBranchOffice', 'id', id)
        api.setRparamsObj('changeBranchOffice', 'branch_office', branch_office.value)

        api.manageApi('changeBranchOffice', (data) => {
          if (data.data) {
            // 成功
            self.parentNode.innerHTML = `<span class="t-color-blue success-msg">${data.message}</span>`
            setTimeout(function () {
              location.reload(true)
            }, 500);
          } else {
            errormsg.innerHTML = data.message
          }
        })
      } catch (e) {
        if (e === 'validerror_required') {
          errormsg.innerHTML = "「信毎支社」は必須項目です"
        } else if (e === 'validerror_maxlength') {
          errormsg.innerHTML = "「自社担当支社・担当者」は最大40文字です"
        } else {
          errormsg.innerHTML = "システムエラーです。管理者に連絡してください"
        }
      }

    }

    util.setEventsRtSelf('click', btns, changeStatusCb.bind(this))
  }

  /**
   * manage, manage/joboffers:url_token 広告主が広告会社の担当者名を変更
   */
  changeAgencyPicname() {
    const btns = document.querySelectorAll('[data-joboffer_agency_picname_change]')

    const changeStatusCb = (self) => {
      const id = self.getAttribute('data-joboffer_agency_picname_change')
      const errormsg = document.querySelector('[data-stateChangeAgencyPicnameMsg="' + id + '"]')

      try {
        if (!id) {
          throw "validerror"
        }

        const agencyPicnameInput = document.querySelector('[data-stateChangeAgencyPicname="' + id + '"]')

        /*
        if (!agencyPicnameInput.value) {
          throw "validerror_required"
        }
        */

        errormsg.innerHTML = ''

        api.setRparamsObj('changeAgencyPicname', 'id', id)
        api.setRparamsObj('changeAgencyPicname', 'agency_picname', agencyPicnameInput.value)

        api.manageApi('changeAgencyPicname', (data) => {
          if (data.data) {
            // 成功
            self.parentNode.innerHTML = `<span class="t-color-blue success-msg">${data.message}</span>`
            setTimeout(function () {
              location.reload(true)
            }, 500);
          } else {
            errormsg.innerHTML = data.message
          }
        })
      } catch (e) {
        if (e === 'validerror_required') {
          errormsg.innerHTML = "「自社担当支社・担当者」は必須項目です"
        } else if (e === 'validerror_maxlength') {
          errormsg.innerHTML = "「自社担当支社・担当者」は最大40文字です"
        } else {
          errormsg.innerHTML = "システムエラーです。管理者に連絡してください"
        }
      }

    }

    util.setEventsRtSelf('click', btns, changeStatusCb.bind(this))
  }

  /**
   * manage/joboffers/:url_token セレクトボックス変更時、コピー元recruit_idをパラメータに付与する。
   */
  setCopyParam () {
    const setParam = (self) => {
      const tgtid = self.getAttribute('data-copy_recruit')
      if (tgtid) {
        const tgt = document.querySelector('[data-copy_recruit_tgt="' + tgtid + '"]')
        if (tgt) {
          tgt.setAttribute('href', tgt.getAttribute('data-copy_recruit_originpath') + '&recruit_id=' + self.value)
        }
      }
    }

    const copysources = document.querySelectorAll('[data-copy_recruit]')
    util.setEventsRtSelf('change', copysources, setParam.bind(this))
  }

  /**
   * manage/joboffers/:url_token?adspot_id=* adspot_idパラメータありでアクセスされた時に自動スクロール
   */
  autoScroll2Tgt (params) {
    if (params.adspot_scroll_id) {
      const tgtid = params.adspot_scroll_id
      const tgt = document.getElementById('adspot_' + tgtid)
      if (tgt) {
        setTimeout(function() {
          tgt.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }, 500)
      }
    }
  }
}
